<template>
  <div id="chart-container2"></div>
</template>

<script>
import Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
import highchartsDark from 'highcharts/themes/dark-unica';
Highcharts3D(Highcharts);
highchartsDark(Highcharts);

export default {
  name: 'pieChart2',
  props: ['chart'],
  mounted() {
   const chart = Highcharts.chart('chart-container2', {
      chart: {
        type: 'pie',
        options3d: {
          enabled: true,
          alpha: 55,
          beta: 0
        }
      },
      title: {
        text: 'Total Tax',
        fontWeight: 'bolder'
      },
      plotOptions: {
        pie: {
          depth: 45,
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.1f}% {point.name}'
          }
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      series: [
        {
          name: 'Data',
          size: '60%',
          data: this.chart
        }
      ]
    });
    const renderer = chart.renderer;
    renderer.text('Unreconciled Tax', 10, 350).css({
      color: 'white',
      fontSize: '20px',
      fontWeight: 'bolder'
    }).attr({
      zIndex: 5
    }).add();
    const rendere = chart.renderer;
    rendere.text('Reconciled Tax', 180, 100).css({
      color: 'white',
      fontSize: '20px',
      fontWeight: 'bolder'
    }).attr({
      zIndex: 5
    }).add();
  }
};
</script>
